// ─────────────────────────────────────────────
//  CaseFactsSection — the case itself: its START / END times and its surgeon.
//  Both write the same assignment row the OR Board reads, so the board updates
//  live.
//
//  ⚠️ THE CURRENT SURGEON IS ALWAYS AN OPTION, even when it is not on the
//  facility's configured list. Sheet-imported names arrive as free text
//  ("Gaskins + 1", "NARULA") and a picker that silently dropped them would blank
//  the surgeon the moment anyone opened this modal on that case — a destructive
//  edit nobody asked for, in a dialog opened to change the times. Same rule as
//  assignmentRow.cells' `surgeonOrphan`.
//
//  The surgeon list is the SAME one the Daily List grid uses
//  (procedure_refs.surgeons), so three surfaces cannot drift into three
//  spellings of one surgeon.
// ─────────────────────────────────────────────
import React from "react";
import Button from "../Button";
import st from "./caseModalStyles";
import { START_TIME_OPTIONS, END_TIME_OPTIONS } from "../assignmentRow.cells";

export default function CaseFactsSection({
  startTime, setStartTime,
  endTime, setEndTime,
  savedStartTime, savedEndTime,
  onSaveTimes,
  surgeon, setSurgeon, savedSurgeon, surgeons = [], onSaveSurgeon,
  busy = false,
}) {
  return (
    <>
      <div style={st.section}>
        <div style={st.sectionTitle}>Case times</div>
        <div style={st.timesRow}>
          <label style={st.field}>
            Start
            <select style={st.select} value={startTime} onChange={(e) => setStartTime(e.target.value)}>
              <option value="">—</option>
              {startTime && !START_TIME_OPTIONS.includes(startTime) && <option value={startTime}>{startTime}</option>}
              {START_TIME_OPTIONS.map((t) => <option key={t} value={t}>{t}</option>)}
            </select>
          </label>
          <label style={st.field}>
            End
            <select style={st.select} value={endTime} onChange={(e) => setEndTime(e.target.value)}>
              <option value="">—</option>
              {endTime && !END_TIME_OPTIONS.includes(endTime) && <option value={endTime}>{endTime}</option>}
              {END_TIME_OPTIONS.map((t) => <option key={t} value={t}>{t}</option>)}
            </select>
          </label>
          <Button
            onClick={onSaveTimes}
            disabled={busy || (startTime === savedStartTime && endTime === savedEndTime)}
          >
            Save times
          </Button>
        </div>
      </div>

      <div style={st.section}>
        <div style={st.sectionTitle}>Surgeon</div>
        <div style={st.row}>
          <label style={st.field}>
            Surgeon
            <select
              style={st.select}
              aria-label="Surgeon"
              value={surgeon}
              onChange={(e) => setSurgeon(e.target.value)}
            >
              <option value="">— none —</option>
              {surgeon && !surgeons.includes(surgeon) && <option value={surgeon}>{surgeon}</option>}
              {surgeons.map((s) => <option key={s} value={s}>{s}</option>)}
            </select>
          </label>
          <Button onClick={onSaveSurgeon} disabled={busy || surgeon === savedSurgeon}>
            Save surgeon
          </Button>
        </div>
      </div>
    </>
  );
}
